var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9c27b0",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34999 6.34893L4.92999 4.92893C6.80527 3.05422 9.34835 2.00107 12 2.00107C14.6516 2.00107 17.1947 3.05422 19.07 4.92893L17.65 6.34893C16.1503 4.85283 14.1184 4.01263 12 4.01263C9.88162 4.01263 7.84972 4.85283 6.34999 6.34893Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17001 9.16893L7.76001 7.75893C8.88501 6.63533 10.41 6.00421 12 6.00421C13.59 6.00421 15.115 6.63533 16.24 7.75893L14.82 9.17893C14.0733 8.42776 13.0592 8.0034 12 7.99893C11.4746 7.99852 10.9542 8.10163 10.4686 8.30239C9.98303 8.50314 9.54176 8.79759 9.17001 9.16893Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.9989H14C14 11.5294 13.7893 12.0381 13.4142 12.4131C13.0391 12.7882 12.5304 12.9989 12 12.9989C11.4696 12.9989 10.9609 12.7882 10.5858 12.4131C10.2107 12.0381 10 11.5294 10 10.9989H6C5.46957 10.9989 4.96086 11.2096 4.58579 11.5847C4.21071 11.9598 4 12.4685 4 12.9989V21.9989H20V12.9989C20 12.4685 19.7893 11.9598 19.4142 11.5847C19.0391 11.2096 18.5304 10.9989 18 10.9989ZM6 17.9989V14.9989H18V17.9989H6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.9989C13 11.5512 12.5523 11.9989 12 11.9989C11.4477 11.9989 11 11.5512 11 10.9989C11 10.4466 11.4477 9.99893 12 9.99893C12.5523 9.99893 13 10.4466 13 10.9989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSensor);
export default __webpack_public_path__ + "static/media/icon-sensor.bd69703c79083dd548cf144e6209c441.svg";
export { ForwardRef as ReactComponent };